import { render, staticRenderFns } from "./AiMessageGenerate.vue?vue&type=template&id=0387bc7a&scoped=true&"
import script from "./AiMessageGenerate.vue?vue&type=script&lang=ts&"
export * from "./AiMessageGenerate.vue?vue&type=script&lang=ts&"
import style0 from "./AiMessageGenerate.vue?vue&type=style&index=0&id=0387bc7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0387bc7a",
  null
  
)

export default component.exports